import React, { useState, useEffect } from 'react';
import Games from '../../../../class/Game_copy/Game';
import { useTranslation } from 'react-i18next';

const jackpotConfig = [
  { key: 'bronze', className: 'bronze_j', icon: '/assets/img/icon-bronze-j.png', name: 'Bronze' },
  { key: 'silver', className: 'silver_j', icon: '/assets/img/icon-silver-j.png', name: 'Silver' },
  { key: 'gold', className: 'gold_j', icon: '/assets/img/icon-gold-j.png', name: 'Gold' },
];

const JackPot = ({ AuthService }) => {
  const [jackpots, setJackpots] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchJackpots = async () => {
      setLoading(true);
      try {
        const user_id = AuthService.getCustom('user_id');
        const response = await Games.getJackPot(user_id);

        console.log("Jackpot response:", response);

        if (response.status === "ok" && response.params) {
          if (Object.keys(response.params).length > 0) {
            let data = response.params;


            // Розподіляємо дані за типами джекпотів
            const bronze = data[1];
            const silver = data[2];
            const gold = data[3];

            setJackpots({ bronze, silver, gold });
          } else {
            setJackpots(null);
          }

        } else {
          setError(t('Failed_to_fetch_jackpots'));
          setJackpots(null);
        }
      } catch (err) {
        setError(t('An_error_occurred_while_fetching_jackpots'));
      } finally {
        // console.log("CHANGE LOADING STATE")
        setLoading(false);
      }
    };

    fetchJackpots();
  }, [AuthService]);

  if (loading) return null;

  return (
    <>
      {jackpots != null && (
        <div className={`jackpot-container ${loading ? 'loading-blur' : ''}`}>
          <div className="jackpot-values">
            <div className="jackpot-scroll">
              {jackpotConfig.map(({ key, className, icon, name }) => (
                <div key={key} className={`value_j ${className}`}>
                  <span>
                    <img src={icon} alt={`${name} icon`} />
                    {name} jackpot
                  </span>
                  <strong>{parseFloat(jackpots[key] || 0).toFixed(2)} {AuthService.getCustom('currency')}</strong>
                </div>
              ))}
              <div className="value_j bronze_j">
                <span>
                  <img src="/assets/img/icon-bronze-j.png" alt="Bronze icon" />
                  Bronze jackpot
                </span>
                <strong>{parseFloat(jackpots.bronze || 0).toFixed(2)} {AuthService.getCustom('currency')}</strong>
              </div>

            </div>
          </div>
          {error && <div className="error">{error}</div>}
        </div>
      )}
    </>
  )
};

export default JackPot;